import { SeoInfo } from '@core/domain/models/seo.models';

/**
 * SEO State Model
 */
export interface SeoState {
    homeUrls?: string[];
    lastSectionTranslated?: string;
}

/**
 * SEO State initializer
 */
export const seoInitialState: SeoState = { };

export const InitialSeoInfo: SeoInfo = {
    title: null,
    metaTitle: null,
    metaDescription: null,
    seoProductH1: null,
    mainHeader: null,
    longDescription: null,
    secondaryTitle: null,
    secondaryDescription: null,
    productId: null,
    categoryId: null,
};
